<template>
    <transition name="fade slide-down">
        <div v-show="isFormVisible" class="guestform-layer">
            <div class="guestform-layer__container">
                <div class="guestform-layer__languages-layer">
                    <LanguageSwitch
                        class="header__languages"
                        :languages="languages"
                        :language="language"
                        @select="select" />
                </div>
                <svgicon icon="virus"  color="currentColor" class="guestform-layer__virus-icon"/>
                <span class="guestform-layer__headline">COVID-19 Check</span>

<!--                <span class="guestform-layer__title">{{ title }}</span>-->

                <input autoFocus v-model="first_name"
                       :placeholder="bclang('Vorname')"
                       class="guestform-layer__input" type="text" required/>
                <input v-model="last_name"
                       :placeholder="bclang('Nachname')"
                       class="guestform-layer__input" required/>
                <input v-model="address"
                       :placeholder="bclang('E-Mail-Adresse')"
                       class="guestform-layer__input" required type="email"/>

                <div v-for="(option,index) in options" class="guestform-layer__options" v-bind:key="option">
                    <label class="guestform-layer__checkbox-container">
                        <input type="checkbox" v-bind:id="index" v-bind:value="index" v-model="checkedOptions">
                        <span class="guestform-layer__checkbox-container checkmark"></span>
                        <span class="guestform-layer__checkbox-container label">{{ option }}</span>
                    </label>
                </div>
                <div class="guestform-layer__button-container">
                    <button v-bind:disabled="!isSubmitEnabled" v-on:click="submit" class="guestform-layer__button button">
                        {{ bclang("Eingaben absenden")}} </button>
                </div>
            </div>
            <button v-show="userHasEnteredDetails" @click="close" class="guestform-layer__close is-cross">Schließen</button>
        </div>
    </transition>
</template>

<script>
import Options from "../constants/guest-form";
import axios from 'axios';

const LOCAL_STORAGE_KEY = 'guestId';

export default {
    name: 'GuestFormLayer',
    computed: {
        userHasEnteredDetails() {
            return localStorage.getItem(LOCAL_STORAGE_KEY + this.id);
        },
        isFormVisible() {
            return this.required && !this.userHasEnteredDetails && !this.isHidden
        },
        options() {
            return Options[this.language]
        },
        isSubmitEnabled() {
            if (!this.checkedOptions || !this.options)
                return false;
            if (this.first_name.trim().length === 0 ||
                this.last_name.trim().length === 0 ||
                this.address.trim().length === 0)
                return false;
            return this.checkedOptions.length === this.options.length
        }
    },
    watch: {
      isFormVisible: function (newVisible) {
          if (newVisible === true) {
              document.body.classList.add('is-modal-open');
          } else
              document.body.classList.remove('is-modal-open');
      }
    },
    data() {
        return {
            isHidden: false,
            first_name: "",
            last_name: "",
            address: "",
            checkedOptions: [],
            Options,
        };
    },
    props: ["required", "title", "id", "select", "language", "languages"],
    methods: {
        close() {
            this.isHidden = true;
        },
        submit() {
            if (!this.isSubmitEnabled)
                return;

            let formData = new FormData();
            formData.set("first_name", this.first_name);
            formData.set("address", this.address);
            formData.set("last_name", this.last_name);
            axios({
                method: "post", url: "/guest/" + this.id,
                data: formData,
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(res => {
                localStorage.setItem(LOCAL_STORAGE_KEY + this.id, res.data.id);
                this.isHidden = true;
            });
        }
    }
}
</script>

<style lang="scss">

@import '../scss/config';
$close-size: size(font-regular);
$input-height: rem(48);
$checkbox-size: rem(20);
$button-size: rem(50);
$frame-size: medium;
$padding: size($frame-size);

.guestform-layer {
    @include frame($frame-size);
    font-size: size(font-tiny);
    background-color: map-get($f-color-colors, "background");
    color: map-get($f-color-colors, "foreground");
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 110;
    padding-right: $close-size + $padding;
    width: 100%;
    height: 100vh;
    overflow-y:auto;

    a {

        &,
        &:active,
        &:visited {
            text-decoration: underline;
        }
    }

    &__close {
         @include cross-button((
            size: $close-size,
            color: color(background),
            roundness: 0,
            thickness: 0.1,
        ));

        position: absolute;
        top: $padding;
        right: $padding;
    }

    &__container {
        display: flex;
        flex-direction: column;
        margin: $padding;

        & > * {
            margin-bottom: $padding;
        }

    }

    &__options {
        display: flex;
    }



    &__checkbox {

    }

    &__headline {
        font-size: size(font-headline);
        align-self: center;
        margin-bottom: $padding*2;
        text-transform: uppercase;
    }

    &__input {
        ::placeholder {
            color: color(middleground);
        }
        &:valid {
            border: solid 2px color(foreground);
        }
        /*&:invalid {*/
        /*    border: solid 2px color(danger);*/
        /*}*/
        height: $input-height;
        padding: $padding;

        color: color(foreground);
        background: color(background);
        border: solid 2px color(middleground);
    }

    &__checkbox-container {
        display: block;
        position: relative;
        /*padding-left: rem(35);*/
        cursor: pointer;
        user-select: none;
        &.label {
            padding-left: rem(30);
            line-height: 1.21;
            color: color(middleground);
        }
        & input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;

        }
        &.checkmark {
            position: absolute;
            top: rem(4);
            left: 0;
            height: $checkbox-size;
            width: $checkbox-size;
            background: color(background);
            border: solid 2px color(middleground);
            &:after {
                content: "";
                position: absolute;
                display: none;

                left: rem(7);
                top: rem(2);
                width: rem(5);
                height: rem(10);
                border: solid white;
                border-width: 0 rem(2) rem(2) 0;
                -webkit-transform: rotate(45deg);
                -ms-transform: rotate(45deg);
                transform: rotate(45deg);
            }
        }
        /*&:hover input ~ .checkmark {*/
        /*    background-color: #ccc;*/
        /*}*/
        & input:checked ~ .checkmark {
            background: color(background);
            border: solid 2px color(foreground);
            &:after {
                display: block;
            }
        }

        & input:checked ~ .label {
            color: color(foreground);
        }

    }

    &__button {
        margin-top: rem(60);
        height: $button-size;
        padding: rem(12) rem(18);
        font-weight: 600;
        border-radius: rem(5);
        border: none;
        &:disabled {
            background-color: color(middleground);
        }
    }

    &__button-container {
        display: flex;
        justify-content: center;
        padding-bottom: rem(60);
    }

    &__virus-icon {
        height: rem(80);
    }

    &__languages-layer {
        display:flex;
        justify-content: flex-end;
    }
}
</style>
